import { getTranslations } from './lib/dataFormatter'
const messages = getTranslations()
export default messages
